import React from "react";
import { Radio } from "antd";

const AnswerRadio = ({ question }) => {
	return (
		<div className="answers-container">
			{question.answers.map((answer) => (
				<div key={answer.id} className="answer-item">
					<Radio key={answer.id}>{answer.name}</Radio>
				</div>
			))}
		</div>
	);
};

export default AnswerRadio;
